module.exports = __webpack_public_path__ + "img/erp-logos_0005_vintrace.3ad876e1.jpg";